const idOf = value => String(value?._id || value?.$oid || value || '').trim();
const mappingKeys = ['stores_maped', 'store_maped', 'stores_mapped', 'store_mapped', 'storeMaped', 'storeMapped', 'store_map', 'store_mappings', 'stores_map'];

export function mappedGlovoVendors(platform, store) {
  const localIds = [idOf(store.storeId || store._id), idOf(store.value || store.storeCode)].filter(Boolean);
  const vendors = new Set();
  const visit = mapping => {
    if (!mapping || typeof mapping !== 'object') return;
    if (Array.isArray(mapping)) return mapping.forEach(visit);
    const local = mapping.store_id || mapping.storeId || mapping.store || mapping.store_code || mapping.storeCode;
    const remote = mapping.remote_store_id || mapping.remoteStoreId || mapping.vendorId || mapping.vendor_id || mapping.remote_id;
    if (localIds.includes(idOf(local)) && /^\d+$/.test(String(remote || ''))) vendors.add(String(remote));
    for (const [key, value] of Object.entries(mapping)) {
      if (/^\d+$/.test(key) && localIds.includes(idOf(value))) vendors.add(key);
    }
  };
  for (const data of [platform.additionnal_data, platform.additionnal_data?.portal]) {
    mappingKeys.forEach(key => visit(data?.[key]));
  }
  return [...vendors];
}

export function buildGlovoLiveSyncTargets(platforms, store, platformType) {
  const storeId = idOf(store?.storeId || store?._id);
  if (!storeId || store?.isAll) throw new Error('Veuillez sélectionner un magasin précis.');
  return platforms.flatMap(platform => {
    const type = String(platform?.type || '').toLowerCase();
    if (!['glovo', 'glovo_sisters'].includes(type) || (platformType && type !== platformType) ||
        platform?.additionnal_data?.isportal !== true) return [];
    const mapped = mappedGlovoVendors(platform, store);
    const assigned = (platform.store_ids || []).map(idOf);
    if (assigned.length && !assigned.includes(storeId) && !mapped.length) return [];
    const vendors = mapped.length ? mapped : type === 'glovo' ? [idOf(store.value || store.storeCode)] : [];
    if (!vendors.length && type === 'glovo_sisters') {
      return [{ plateformId: idOf(platform._id || platform.id), storeId,
        error: 'Glovo Sisters : correspondance magasin / identifiant distant manquante.' }];
    }
    return vendors.filter(vendorId => /^\d+$/.test(vendorId)).map(vendorId => ({
      plateformId: idOf(platform._id || platform.id), storeId, vendorId,
    }));
  });
}
